// extracted by mini-css-extract-plugin
export default {"navContainer":"NavSection_navContainer__F6Gnr"};